import { $Q, $Qll } from "../utils/query-selector";
import { toggleDataActive, dataToggle } from "../utils/toggle-dataset";

/**
 * On window memory
 * @param {HTMLElement} target - Target element with data window id
 * @returns URL history push
 */
const windowMemory = (target) => {
  const base = target
    ? location
    : location.origin + location.pathname;

  const url = new URL(base);

  if (target) {
    const id = target.getAttribute('data-window-id');
    url.searchParams.set("window", id);
  }

  return history.pushState({}, "", url);
}

/**
 * Previous element window
 * @param {HTMLElement} target - target with a window parent
 * @returns HTMLElement or null
 */
export const previousWindow = (target) => {
  const parentSubWindow = target.parentNode;
  const parentLayer = parentSubWindow.closest('.window-layer-js');
  if (!parentLayer) return null;

  return parentLayer.previousElementSibling;
}

/**
 * Action on click item window
 * @param {{ scope: HTMLElement, memory: boolean }} params - parament on window actions
 * @param {HTMLElement} params.scope - scope or parent target
 * @param {Boolean} params.memory - if support memory item
 */
export const windowsToggle = ({ scope, memory = false }) => {
  const parentNode = $Q(scope);
  const itemToggle = $Qll('.window-item-js', parentNode);
  const layerItems = $Qll('.window-layer-close-js', parentNode)

  itemToggle.forEach((item) => item.addEventListener('click',
    () => {
      item.setAttribute('data-active', 'true');
      if (!memory) return;

      windowMemory(item);
    },
  ))

  layerItems.forEach((layeritem) => {
    layeritem.addEventListener('click', () => {
      const layer = layeritem.closest('.window-layer-js');
      if (!layer) return null;
      const sibling = layer.previousElementSibling;
      sibling.setAttribute('data-active', 'false');

      if (!memory) return;

      const previous = previousWindow(sibling);
      windowMemory(previous);
    });
  })
}

/**
 * Init resource windows
 * @param {{ control: string, target: string }} params - Init parametres
 * @param {String} params.control - Reference controller the open modal window
 * @param {String} params.target - Reference of the modal window
 */
export const initWindows = ({ control, target }) => {
  toggleDataActive(
    control,
    target,
    {
      overlay: true,
      closeSelector: '.window-close-js',
    },
  );
}

/**
 * Load memory window of the proxy
 * @returns get proxy params and open modal window
 */
export const onloadMemory = () => {
  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  if (!params.window) return;
  const memoryWindow = $Q('#nav-list-movil-js');
  const subWindow = $Q(`.window-item-js[data-window-id="${params.window}"]`);

  if (!memoryWindow || !subWindow) return;

  const parentWindow = previousWindow(subWindow);
  if (parentWindow) {
    parentWindow.setAttribute('data-active', 'true');
  }

  subWindow.setAttribute('data-active', 'true');
  dataToggle(memoryWindow, true);
}
